<template>
    <div>
        <b-modal :id="$options.name" size="xl">
            <template v-slot:modal-header="{ close }">
                <div class="row" style="width: 100%">
                    <div class="col-md-10 offset-md-1 text-center d-flex justify-content-center">
                        <h3> {{ __('select_documents_to_link_to_the_contract') }} </h3>
                        <button-open-help-modal :inExtraDiv="false" :helpName="helpName" :color="'black'"/>
                    </div>
                    <div class="col-md-1">
                        <button class="close" type="button" @click="close()">
                            <span aria-hidden="true">&times;</span>
                            <span class="sr-only">{{ __('close') }}</span>
                        </button>
                    </div>
                </div>
            </template>

            <template v-slot:default>
                <ContractConnectDocumentTable
                    :permissionsAccess="permissionsAccess"
                    :checkedDocuments="checkedDocuments"
                    :documents="documents"
                    @checkAll="checkAll"
                    @checked="changeChecked"
                />
            </template>
            <template v-slot:modal-footer>
                <button
                    class="btn btn-white"
                    type="button"
                    @click="closeModal()"
                >
                    {{ __("cancel") }}
                </button>
                <button
                    :disabled="!isCheckedAny || isLoading"
                    class="btn btn-primary"
                    type="button"
                    @click="attachToContract"
                >
                    <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        v-if="isLoading"
                    ></span>
                    {{ __("save") }}
                </button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Events from "../../services/Events";
import ContractConnectDocumentTable from "../tables/contract/ContractConnectDocument/ContractConnectDocumentTable";
import {DocumentService} from "../../modules/document/services/DocumentService";
import hasPermissions from "../../mixins/hasPermissions";
import hasTooltips from "../../mixins/hasTooltips";
import inputEmit from "../../mixins/inputEmit";
import hasErrors from "../../mixins/hasErrors";

export default {
    name: "ModalConnectDocumentContract",
    components: {ContractConnectDocumentTable},
    props: {
        contractId: {
            type: Number,
            required: true,
        },
        helpName: {
            type: String,
            required: true,
        },
    },
    mixins: [hasPermissions],
    data() {
        return {
            documentService: new DocumentService({}),
            documents: [],
            checkedDocuments: [],
            isLoading: false,
        };
    },
    computed: {
        isCheckedAny() {
            return this.checkedDocuments.length > 0;
        },
    },
    methods: {
        async openModal() {
            const {data} = await this.fetchDocuments();
            this.documents = data.data;
            this.$bvModal.show(this.$options.name);
            setTimeout(() => {
                $('.modal-dialog').draggable({
                    handle: ".modal-header"

                });
            }, 1000)
        },
        closeModal() {
            this.documents = [];
            this.$bvModal.hide(this.$options.name);
        },
        async fetchDocuments() {
            return this.axios.get(`/records/documents/documents-to-connect-with/${this.contractId}`);
        },
        async attachToContract() {
            this.toogleLoading();
            let documentIds = await this.documentService.getRelatedDocumentsIds(this.checkedDocuments);
            documentIds = await this.documentService.checkVatRatesAvailable(documentIds, this.contractId)
            if (documentIds.length > 0) {
                try {
                    const {data} = await this.axios.post(`/records/documents/attach-to-contract/${this.contractId}`, {documentIds: this.checkedDocuments});
                    toastr['success'](data).css('border', '0px');
                    this.closeModal();
                    location.reload();
                } catch (e) {
                    this.toogleLoading(false);
                    toastr['error'](e).css('border', '0px');
                }
            } else {
                this.toogleLoading(false);
            }
        },
        checkAll(checked) {
            if (checked) {
                this.checkedDocuments = this.documents.map((document => document.id));
            } else {
                this.checkedDocuments = [];
            }
        },
        changeChecked({value, checked}) {
            if (checked) this.checkedDocuments.push(value);
            else {
                this.checkedDocuments.splice(this.checkedDocuments.indexOf(value), 1);
            }
        },
        toogleLoading(isLoading = true) {
            this.isLoading = isLoading;
            toggleLoader(isLoading);
        },
    },
    mounted() {
        Events.$on('openConnectDocumentContract', this.openModal);
    },
};
</script>

